import React from 'react';
import { Card } from '../components/ui/card';
import { Award, DollarSign, Users, Zap } from 'lucide-react';
import { mockData } from '../data/mockData';

const iconMap = {
  Award: Award,
  DollarSign: DollarSign,
  Users: Users,
  Zap: Zap
};

const WhyChooseUsSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-amber-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
              Why Choose Us for Trademark Registration
            </h2>
            <div className="w-24 h-1 bg-amber-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We combine legal expertise, transparent pricing, and personalized service to make trademark registration simple and stress-free.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {mockData.whyChooseUs.map((item, index) => {
              const IconComponent = iconMap[item.icon];
              return (
                <Card
                  key={index}
                  className="p-6 text-center hover:shadow-xl transition-all duration-300 bg-white border-b-4 border-blue-900 hover:border-amber-500 group"
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-800 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:from-amber-500 group-hover:to-amber-600 transition-all">
                    <IconComponent className="text-white" size={32} />
                  </div>
                  <h3 className="text-xl font-bold text-blue-900 mb-3">
                    {item.title}
                  </h3>
                  <p className="text-gray-600">
                    {item.description}
                  </p>
                </Card>
              );
            })}
          </div>

          <div className="mt-12 grid md:grid-cols-3 gap-6">
            <Card className="p-6 bg-white shadow-lg">
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-900 mb-2">15+</div>
                <div className="text-gray-600">Years of Experience</div>
              </div>
            </Card>
            <Card className="p-6 bg-white shadow-lg">
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-900 mb-2">1000+</div>
                <div className="text-gray-600">Trademarks Registered</div>
              </div>
            </Card>
            <Card className="p-6 bg-white shadow-lg">
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-900 mb-2">98%</div>
                <div className="text-gray-600">Approval Success Rate</div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
